import React, { lazy, Suspense, useState } from "react";
import { SubHeading } from "../../shared/Components";
import { useQuery } from "@tanstack/react-query";
import { getAxios } from "../../shared/Services/commonService";
import { API_USER_SESSION_HISTORY } from "../../utils/api/ApiConstant";
import { useLocation } from "react-router-dom";

const LoginHistoryBody = lazy(() => import("./LoginHistoryBody"));

const LoginHistory = () => {
  const location = useLocation();

  const rowData = location?.state?.rowData;

  const [queryParams, setQueryParams] = useState({
    pageNumber: 1,
    pageSize: 20,
    ...(rowData?.id && { userId: rowData.id }),
  });

  const { isLoading, data, refetch } = useQuery({
    queryKey: ["userData", queryParams],
    queryFn: async () => await getAxios(API_USER_SESSION_HISTORY, queryParams),
  });

  return (
    <>
      <SubHeading />

      <Suspense fallback={<div>Loading...</div>}>
        <LoginHistoryBody
          data={data?.items || []}
          totalPages={data?.totalPages || 1}
          totalRecords={data?.totalRecords || 0}
          isLoading={isLoading}
          setQueryParams={setQueryParams}
          queryParams={queryParams}
          refetch={refetch}
          rowData={rowData}
        />
      </Suspense>
    </>
  );
};

export default LoginHistory;
